import { render, staticRenderFns } from "./BlockUnblock.vue?vue&type=template&id=5f647663&"
import script from "./BlockUnblock.vue?vue&type=script&lang=js&"
export * from "./BlockUnblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports